const { registerBlockType } = wp.blocks;
const { RichText, InspectorControls, MediaUpload, MediaUploadCheck } =
  wp.blockEditor;
const { Button, PanelBody, SelectControl } = wp.components;
const { Fragment } = wp.element;
const { __ } = wp.i18n;

registerBlockType('pg/quote-wrapper', {
  title: 'PG Quote Block with Wrapper',
  icon: 'businessman',
  category: 'layout',
  attributes: {
    content: { source: 'html', selector: 'p' },
    src: { source: 'attribute', attribute: 'src', selector: 'img' },
    alt: {
      type: 'string',
      source: 'attribute',
      attribute: 'alt',
      selector: 'img',
    }, // Added alt attribute
    description: { source: 'html', selector: '.description' },
    layout: { type: 'string', default: 'default' },
    sectionClass: {
      type: 'string',
      default: 'section-light-secondary',
    },
  },

  edit: ({ attributes, setAttributes }) => {
    const { content, src, alt, description, sectionClass, layout } = attributes;

    const onChangeSectionClass = (newClass) => {
      setAttributes({ sectionClass: newClass });
    };

    const onChangeLayout = (newLayout) => {
      setAttributes({ layout: newLayout });
    };

    return (
      <Fragment>
        <InspectorControls>
          <PanelBody title={__('Section Settings')}>
            <SelectControl
              label={__('Section Class')}
              value={sectionClass}
              options={[
                { label: 'Dark Secondary', value: 'section-dark-secondary' },
                { label: 'Dark Primary', value: 'section-dark-primary' },
                { label: 'Light Primary', value: 'section-light-primary' },
                { label: 'Light Secondary', value: 'section-light-secondary' },
              ]}
              onChange={onChangeSectionClass}
            />
            <SelectControl
              label={__('Layout')}
              value={layout}
              options={[
                { label: 'Default', value: 'default' },
                { label: 'Centered', value: 'centered' },
              ]}
              onChange={onChangeLayout}
            />
          </PanelBody>
        </InspectorControls>
        <section className={sectionClass}>
          <div className="section-wrapper">
            <div className="editor-component">
              <div
                className={`quote-block${layout === 'centered' ? ' quote-block-centered' : ''}`}
              >
                {layout !== 'centered' && (
                  <div className="photo-wrapper">
                    <MediaUploadCheck>
                      <MediaUpload
                        onSelect={
                          (media) =>
                            setAttributes({
                              src: media.url,
                              alt: media.alt || '',
                            }) // Capture alt attribute
                        }
                        allowedTypes={['image']}
                        value={src}
                        render={({ open }) => (
                          <>
                            <Button
                              isPrimary
                              onClick={open}
                              className={'buttonOnTopIndex'}
                            >
                              {src ? __('Change Image') : __('Upload Image')}
                            </Button>
                            {src && (
                              <img
                                src={src}
                                alt={alt || ''}
                                className={'logotype'}
                              />
                            )}
                          </>
                        )}
                      />
                    </MediaUploadCheck>
                  </div>
                )}
                <div className="content-wrapper">
                  <RichText
                    tagName="p"
                    placeholder={__('Quote Content..')}
                    className={'quote'}
                    value={content}
                    onChange={(value) => setAttributes({ content: value })}
                  />
                  <RichText
                    tagName="p"
                    placeholder={__('Description..')}
                    className={'description'}
                    value={description}
                    onChange={(value) => setAttributes({ description: value })}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </Fragment>
    );
  },

  save: ({ attributes }) => {
    const { content, src, alt, description, sectionClass, layout } = attributes;

    return (
      <section className={sectionClass}>
        <div className="section-wrapper">
          <div
            className={`quote-block${layout === 'centered' ? ' quote-block-centered' : ''}`}
          >
            {layout !== 'centered' && (
              <div className="photo-wrapper">
                {src && (
                  <img src={src} alt={alt || ''} className={'logotype'} />
                )}{' '}
                {/* Use alt attribute */}
              </div>
            )}
            <div className="content-wrapper">
              <RichText.Content
                className={'quote'}
                tagName="p"
                value={content}
              />
              <RichText.Content
                className={'description'}
                tagName="p"
                value={description}
              />
            </div>
          </div>
        </div>
      </section>
    );
  },
});
